module.exports = __webpack_public_path__ + "img/pocketMockup.ab938b08.png";